'use strict';

namespace Core {
    const enum ChangeFlightTrackingEvent {
        Category = 'Change Flight',
        Action = 'Click',
        Label = 'Change Flight'
    }

    class FlightListing {

        // Attr
        flight: any;
        appliedBags: number;
        nonInfantPassengers: number;
        isFirst: boolean;
        recentlyViewed: boolean;
        signedIn: boolean;
        depositMessage: string;
        buttonType: string;
        flightButtonText: string;
        basePrice: number;
        showPrice: boolean;
        showInfo: boolean;
        showChangeFlight: boolean;
        changeFlightTracking: string;
        trackingPage: string;
        showButton: boolean;
        showTax: boolean;
        showDeposit: boolean;
        showBaggage: boolean;
        flightAction: (f) => void;
        busy: boolean;
        priorityForPreSelection: boolean;

        constructor(
            private broker: any,
            private resourceService: any,
            private $scope: any,
            private occupancyService: any,
            private basketService: any,
            private flightSearch: any,
            private analytics: any,
            private flightDetail: any
        ) {
            //update properties after flight provided ( selected flight )
            if (!this.flight) {
                this.buttonType = this.buttonType ? this.buttonType : 'select';
                const flightWatch = this.$scope.$watch('fl.flight', (value) => {
                    if (value) {
                        this.update();
                        flightWatch();
                    }
                });
            } else {
                this.update();
            }
        }


        update() {
            this.priorityForPreSelection = this.flight.PriorityForPreSelection;
            this.recentlyViewed = this.isFirst && this.flight.RecentlyViewedIndex === 1;
            this.buttonType = this.buttonType ? this.buttonType : 'select';
            this.showButton = this.buttonType === 'none' ? false : true;
            this.showTax = this.showPrice && this.getTotalPrice() > 0 || false;
            this.showDeposit = this.showInfo && this.flight && this.flight.DepositAmount > 0;
            this.showBaggage = TRPCONFIG.Domain.DisplayBaggageFeesLink
                && this.flight
                && this.flight.Legs
                && this.flight.Legs.some(function (leg) { return leg.IsMixedCarrier === true; });
        }

        init() {
            this.depositMessage = this.signedIn
                ? this.resourceService.get('FLIGHTLISTINGDEPOSITCAPTIONSIGNEDIN')
                : this.resourceService.get('FLIGHTLISTINGDEPOSITCAPTION');

            this.flightButtonText = this.buttonType && this.buttonType.toLowerCase() === 'keep'
                ? this.resourceService.get('KEEPTHISFLIGHT')
                : this.resourceService.get('SELECTFLIGHTTEXT');
        }

        showDetails() {
            const passengers = this.occupancyService.getTotalPeopleCounts();
            this.broker.publish('showModalFlightDetails', { flight: this.flight, passengers });
        }

        changeFlight() {
            if (this.changeFlightTracking) {
                this.analytics.track('mixpanel', this.changeFlightTracking);
            } else {
                this.analytics.track('mixpanel', 'ChangeFlightClick');
            }

            if (TRPCONFIG.Domain2.ChangeFlightTrackingEnabled) {
                this.analytics.trackEvent({
                    category: ChangeFlightTrackingEvent.Category + ' ' + this.trackingPage,
                    action: ChangeFlightTrackingEvent.Action,
                    label: ChangeFlightTrackingEvent.Label
                });
            }
            this.flightSearch.resetPageIndex();
            this.basketService.changeJourneyUrl(10);
        }

        stops(n) {
            return n === '' ? undefined : new Array(parseInt(n, 10));
        }

        selectFlightAction() {
            this.flightAction({ f: this.flight });
        }

        getTotalPrice() {
            return this.flight.LeadAdultPrice + this.flight.LeadAdultTax || 0;
        }

        isHFareFlightType(): boolean {
            return this.flightDetail.isHFlightType(this.flight);
        }

    }

    angular
        .module('core')
        .directive('flightListing', (): ng.IDirective => {

            return {
                scope: {},
                restrict: 'E',
                replace: true,
                transclude: true,
                bindToController: {
                    flight: '=',
                    appliedBags: '=',
                    nonInfantPassengers: '=',
                    isFirst: '=',
                    signedIn: '=',
                    buttonType: '@',
                    flightAction: '&',
                    showPrice: '=',
                    basePrice: '@',
                    showInfo: '=',
                    showChangeFlight: '=',
                    changeFlightTracking: '=',
                    trackingPage: '=',
                    busy: '='
                },
                controller: FlightListing,
                controllerAs: 'fl',
                templateUrl: 'partials/home/directivetemplate?type=FlightListing',

                link: function (scope: ng.IScope, el: ng.IAugmentedJQuery, attr, controller: FlightListing) {
                    controller.init();
                }

            };

        });

}
